import jwt_decode from "jwt-decode";

export default function JWTDecode(token) {
    try{
        return jwt_decode(token);
    }
    catch(Error){
        return null;
    }
}